export const truphy = (): boolean => true;
